import {Component, Inject, OnInit} from '@angular/core';
import {NotificationUser} from '../../models/notifications-users/NotificationUserResponse';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {NotificationsUsersService} from '../../services/notifications-users/notifications-users.service';
import {Router} from '@angular/router';
import {NotificationUserBody} from '../../models/notifications-users/NotificationUserBody';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatButtonModule} from '@angular/material/button';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-notifications-dialogue',
  standalone: true,
  imports: [MatTableModule, MatIconModule, MatSortModule, MatPaginatorModule, MatInputModule,
    MatCardModule, MatDividerModule, MatDialogModule, CommonModule,
    ReactiveFormsModule, FormsModule, MatFormFieldModule, MatButtonModule],
  templateUrl: './notifications-dialogue.component.html',
  styleUrl: './notifications-dialogue.component.scss'
})
export class NotificationsDialogueComponent implements OnInit{
  notifications: NotificationUser[] = [];
  subscriptions: Subscription[] = [];

  constructor(
    private dialogRef: MatDialogRef<NotificationsDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { userId: number },
    private notificationsService: NotificationsUsersService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadAllNotifications();
  }

  loadAllNotifications(): void {
    this.subscriptions.push(
      this.notificationsService.getNotifications({ user_id: this.data.userId }).subscribe(response => {
        this.notifications = response.data;
        console.log('this.notifications', this.notifications);
      })
    )
  }

  onNotificationClick(notification: NotificationUser): void {
    if (!notification.is_read) {
      const updateData: NotificationUserBody = {
        user_id: notification.user_id,
        notification_id: notification.notification_id,
        is_read: true,
        read_at: new Date().toISOString()
      };
      this.updateNotificationStatus(notification.id, updateData);
    }
    if (notification.notification?.procedure_id) {
      this.router.navigate(['/procedures/modifier-procedure', notification.notification.procedure_id]);
      this.dialogRef.close();
    }
  }

  updateNotificationStatus(notificationId: number, updateData: NotificationUserBody): void {
    this.subscriptions.push(
      this.notificationsService.updateNotification(notificationId, updateData).subscribe(updatedNotification => {
        const index = this.notifications.findIndex(n => n.id === notificationId);
        if (index !== -1) {
          this.notifications[index] = { ...this.notifications[index], ...updatedNotification.data };
        }
      })
    )
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(x => x.unsubscribe());
  }
}
